import axios from "axios";


export const fetchTournamentCategories = (token, page, limit) => async (dispatch) => {
  dispatch({ type: "FETCH_GOAL_CATEGORY_ADMIN_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/tournament-categories`,
      {
        params: { page, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "FETCH_GOAL_CATEGORY_ADMIN_SUCCESS",
      payload: response.data.body,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_GOAL_CATEGORY_ADMIN_FAILURE",
      payload: error.message,
    });
  }
};